import React, { useContext } from "react";
import GlobalContext from "contexts/GlobalContext";
import "./CMSContent.scss";
import { useHistory } from "react-router-dom";
import { CMSContentWrapper } from "@sia/style-guide";
import cmsAdapter from "common/Adapters/CMSAdapter/CMSAdapter";
import Page from "../Page";

// eslint-disable-next-line
const CMSContent = ({ nodeId, isHash }) => {
  const history = useHistory();
  const { language: languageKey, menuItems, noMenuPages } = useContext(GlobalContext);
  return (
    <div className="cms-content">
      <Page className="benchmarking_page" title={"Benchmarking"}>
        {languageKey &&
          <CMSContentWrapper
            cmsAdapter={cmsAdapter}
            history={history}
            nodeId={nodeId}
            isHash={isHash}
            languageKey={languageKey}
            menuItems={menuItems}
            noMenuPages={noMenuPages}
            environment='benchmarking'
            allowedCTs={['benchmarking_faqs', 'sia_legalpolicy', 'sia_page']}
            browserTitle={undefined} />}
      </Page>
    </div>
  );
};

export default CMSContent;
